import { http, HttpResponse } from "msw";
import { PlessService } from "src/app/shared/pless-service.model";

export const kymw1404Handlers = [
  http.post(PlessService.SERVICE.getNominationGoodsData.url, () => {
    return HttpResponse.json(getNominationGoodsData);
  }),
];

const getNominationGoodsData = {
  "status": "ok",
  "message": "処理完了",
  "result": {
    "obj": {
      "TotalNum": 4,
      "StartDispNum": 1,
      "EndDispNum": 4,
      "NominationGoodsData": [
        {
          "Arranged": " ",
          "WPublish": "Ｗ",
          "OrderCodeDiff": " ",
          "GuideGoodsName": "ちょっと贅沢な珈琲店　スペシャル・ブレンド",
          "GuideStandardName": "７００ｇ（７ｇ×１００袋）",
          "ClassName": "食品",
          "MiddleClassName": "レギュラーコーヒー",
          "SmallClassName": "その他",
          "GuideTempZoneName": "",
          "PlanNum": 96,
          "PlanPrice": 267,
          "Gpr": 20,
          "PCode": "P2670131",
          "PricePattern": "通常",
          "BuyerComment": "大容量飲料",
          "RelateMasterCode": "",
          "EnableIbaraki": "●",
          "EnableTochigi": "●",
          "EnableGunma": "●",
          "EnableChiba": "●",
          "EnableSaitama": "●",
          "EnableTokyo": "●",
          "EnableNagano": "●",
          "EnableNiigata": "●",
          "EnableKuruco": "",
          "OtherMediumTypeFlg": "1",
          "PublishCnt": "0",
          "ParentCnt": "1",
          "MarkCode": "",
          "ThisTimeSupplyPrice": "2780",
          "ItemCode": "",
          "ReceiptSOrderCode": "",
          "OrderNum6Digits": "",
          "StartOrderCode": "",
          "OrderNum": ""
        },
        {
          "Arranged": " ",
          "WPublish": " ",
          "OrderCodeDiff": " ",
          "GuideGoodsName": "パックスナチュロンキッチンスポンジ",
          "GuideStandardName": "１個",
          "ClassName": "住関連",
          "MiddleClassName": "流しまわり",
          "SmallClassName": "たわし",
          "GuideTempZoneName": "",
          "PlanNum": 107,
          "PlanPrice": 21,
          "Gpr": 30.3,
          "PCode": "P2608567",
          "PricePattern": "通常",
          "BuyerComment": "",
          "RelateMasterCode": "",
          "EnableIbaraki": "●",
          "EnableTochigi": "●",
          "EnableGunma": "●",
          "EnableChiba": "●",
          "EnableSaitama": "●",
          "EnableTokyo": "●",
          "EnableNagano": "●",
          "EnableNiigata": "●",
          "EnableKuruco": "",
          "OtherMediumTypeFlg": "0",
          "PublishCnt": "0",
          "ParentCnt": "",
          "MarkCode": "",
          "ThisTimeSupplyPrice": "198",
          "ItemCode": "",
          "ReceiptSOrderCode": "",
          "OrderNum6Digits": "",
          "StartOrderCode": "",
          "OrderNum": ""
        },
        {
          "Arranged": " ",
          "WPublish": "Ｗ",
          "OrderCodeDiff": " ",
          "GuideGoodsName": "永谷園詰合せふりかけ（業務用）",
          "GuideStandardName": "１０９ｇ（５種×１０袋）",
          "ClassName": "食品",
          "MiddleClassName": "乾物ぐるめぐり",
          "SmallClassName": "乾物ぐるめぐり",
          "GuideTempZoneName": "",
          "PlanNum": 215,
          "PlanPrice": 107,
          "Gpr": 38,
          "PCode": "P1316265",
          "PricePattern": "通常",
          "BuyerComment": "大容量",
          "RelateMasterCode": "",
          "EnableIbaraki": "●",
          "EnableTochigi": "●",
          "EnableGunma": "●",
          "EnableChiba": "●",
          "EnableSaitama": "●",
          "EnableTokyo": "●",
          "EnableNagano": "●",
          "EnableNiigata": "●",
          "EnableKuruco": "",
          "OtherMediumTypeFlg": "1",
          "PublishCnt": "0",
          "ParentCnt": "1",
          "MarkCode": "",
          "ThisTimeSupplyPrice": "498",
          "ItemCode": "",
          "ReceiptSOrderCode": "",
          "OrderNum6Digits": "",
          "StartOrderCode": "",
          "OrderNum": ""
        },
        {
          "Arranged": " ",
          "WPublish": "Ｗ",
          "OrderCodeDiff": " ",
          "GuideGoodsName": "産直新潟コシヒカリ",
          "GuideStandardName": "５ｋｇ",
          "ClassName": "米",
          "MiddleClassName": "うるち米",
          "SmallClassName": "普通精米",
          "GuideTempZoneName": "",
          "PlanNum": 215,
          "PlanPrice": 426,
          "Gpr": 17.3,
          "PCode": "P1393391",
          "PricePattern": "特価２",
          "BuyerComment": "表紙　新米",
          "RelateMasterCode": "",
          "EnableIbaraki": "●",
          "EnableTochigi": "●",
          "EnableGunma": "●",
          "EnableChiba": "●",
          "EnableSaitama": "●",
          "EnableTokyo": "●",
          "EnableNagano": "●",
          "EnableNiigata": "●",
          "EnableKuruco": "",
          "OtherMediumTypeFlg": "0",
          "PublishCnt": "1",
          "ParentCnt": "0",
          "MarkCode": "表紙掲載",
          "ThisTimeSupplyPrice": "1980",
          "ItemCode": "",
          "ReceiptSOrderCode": "",
          "OrderNum6Digits": "",
          "StartOrderCode": "",
          "OrderNum": ""
        }
      ]
    }
  }
};